<template>
  <DataIterat
    :headless="fetching"
    searchable
    :filterable="meta && meta.last_page !== 1"
    :bulk-actionable="meta && meta.total > 1"
    actionable
    :paginatable="meta && meta.last_page !== 1"
    v-bind="{ items: ads, loading: fetching, meta }"
    v-on="{ getData: getAds }"
  >
    <DataIteratHeaderContent slot="list-header-content" />
    <DataIteratItemContent
      slot="list-item-content"
      slot-scope="{ dataItem: ad }"
      :ad="ad"
      :lifetime-insights="entityById('facebookLifetimeInsights', ad.lifetimeInsights)"
      v-bind="{ ad }"
    />
  </DataIterat>
</template>

<script>
import { entityComputed } from '@/store/helper';
import DataIterat from '@/components/Ui/DataIterat.vue';
import DataIteratHeaderContent from './DataIteratHeaderContent.vue';
import DataIteratItemContent from './DataIteratItemContent.vue';

export default {
  name: 'FacebookAdList',
  components: {
    DataIterat,
    DataIteratHeaderContent,
    DataIteratItemContent,
  },
  props: {
    fetching: Boolean,
    ads: {
      type: Array,
      default: () => [],
    },
    meta: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...entityComputed,
  },
  methods: {
    getAds(queryParams = {}) {
      this.$emit('get-ads', queryParams);
    },
  },
};
</script>
